import { Component, Input, TemplateRef } from '@angular/core';
import { WeekDay } from '../../utils/week-day';
export class MonthViewHeaderComponent {
   days: WeekDay[];

   locale: string;

   customTemplate: TemplateRef<any>;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'calendar-month-view-header',
  template: `
    <ng-template
    #defaultTemplate
    let-days="days"
    let-locale="locale">
    <div class="cal-cell-row cal-header">
      <div
        class="cal-cell"
        *ngFor="let day of days"
        [class.cal-past]="day.isPast"
        [class.cal-today]="day.isToday"
        [class.cal-future]="day.isFuture"
        [class.cal-weekend]="day.isWeekend"
        [ngClass]="day.cssClass">
        {{ day.date | date: 'EE' }}
      </div>
    </div>
    </ng-template>
    <ng-template
    [ngTemplateOutlet]="customTemplate || defaultTemplate"
    [ngTemplateOutletContext]="{days: days, locale: locale}">
    </ng-template>
  `,
  styles: [`
    .cal-header {
        text-align: center;
        font-weight: bolder;
        padding-top: 5px;
        padding-bottom: 5px;
        border: 1px solid #EBEEF2;
      }

      .cal-cell-row:hover {
        background-color: #fafafa;
      }

      .cal-header .cal-cell {
        padding: 5px 0;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        white-space: nowrap;
        font-size: 12px;
      }

      .cal-cell-row {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
      }
    
      .cal-cell {
        float: left;
        -webkit-box-flex: 1;
            -ms-flex: 1;
                flex: 1;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        -webkit-box-align: stretch;
            -ms-flex-align: stretch;
                align-items: stretch;
        color: #555555;
      }

      .cal-cell-row {
        border-bottom: 1px solid #EBEEF2;
      }
  
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'days': [{ type: Input },],
'locale': [{ type: Input },],
'customTemplate': [{ type: Input },],
};
}

function MonthViewHeaderComponent_tsickle_Closure_declarations() {
/** @type {?} */
MonthViewHeaderComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MonthViewHeaderComponent.ctorParameters;
/** @type {?} */
MonthViewHeaderComponent.propDecorators;
/** @type {?} */
MonthViewHeaderComponent.prototype.days;
/** @type {?} */
MonthViewHeaderComponent.prototype.locale;
/** @type {?} */
MonthViewHeaderComponent.prototype.customTemplate;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
